/**
 * External dependancies
 */
import Vue from 'vue';
import Vuex from 'vuex';

/**
 * The internal dependencies.
 */
import product from './product';
import decks from './decks';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		product,
		decks
	}
});


// WEBPACK FOOTER //
// ./src/store/index.js